import {
  Button,
  DialogActions,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Dialog from "@mui/material/Dialog";
import { CardData, Cart } from "@/interfaces";
import { useCart, useSettings } from "@/contexts";
import { getCardExpirationMonth, getCardExpirationYear } from "@/utils";
import { CardDataInput } from "..";
import { colors } from "@/theme";

export type CardDataInputDialogProps = {
  cart?: Cart;
  open?: boolean;
  onClose?: (cart?: Cart) => void;
};

const CardDataInputDialog: React.FC<CardDataInputDialogProps> = ({
  cart = undefined,
  open = false,
  onClose = undefined,
}) => {
  const { setCard } = useCart();
  const { settings } = useSettings();

  const onCreditCardChange = (cardData?: CardData) => {
    if (!cardData) {
      return;
    }
    console.log("setCard?.(%o, %o);", cardData.cardNumber, cardData.expiration);
    setCard?.(cardData.cardNumber, cardData.expiration);
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      onClose={() => {
        onClose?.();
      }}
      sx={{
        "& .MuiDialogContent-root": {
          marginTop: "16px",
        },
      }}
    >
      <IconButton
        aria-label="back"
        onClick={() => {
          onClose?.();
        }}
        sx={{
          position: "absolute",
          left: 8,
          top: 8,
          color: colors.white,
          background: colors.ozone,
          borderRadius: 0,
          padding: "4px",
          "&:hover": {
            color: colors.white,
            background: colors.ozone,
          },
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      <IconButton
        aria-label="close"
        onClick={() => {
          onClose?.();
        }}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: colors.white,
          background: colors.ozone,
          borderRadius: 0,
          padding: "4px",
          "&:hover": {
            color: colors.white,
            background: colors.ozone,
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <CardDataInput
          cardNumber={cart?.card}
          expirationMonth={getCardExpirationMonth(cart?.cardExpired as string)}
          expirationYear={getCardExpirationYear(cart?.cardExpired as string)}
          onCreditCardChange={onCreditCardChange}
          numberLength={settings?.creditCardNumberLength}
        />
      </DialogContent>
      <DialogActions
        sx={{
          "&.MuiDialogActions-root": {
            "justify-content": "center",
          },
        }}
      >
        <Button
          onClick={() => onClose?.(cart)}
          sx={{
            color: colors.white,
            background: colors.ozone,
            "border-radius": "12px",
            padding: "12px",
            "font-family": "PF DIN Text Pro",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "700",
            "line-height": "16px",
            "text-transform": "uppercase",
            "&:hover": {
              color: colors.white,
              background: colors.ozone,
            },
          }}
        >
          review transaction
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CardDataInputDialog;
